<script lang="ts" setup>
  defineOptions({
    name: 'AppSelect',
    inheritAttrs: false
  });

  // useAttrs() must be obtained once, synchronously during setup, and read from
  // thereafter — computed getters can be lazily re-evaluated during an unrelated
  // reactivity flush (e.g. a Pinia store update elsewhere), where there's no
  // active component instance for useAttrs() to attach to, throwing otherwise.
  const attrs = useAttrs();

  // Generated once per component instance — see AppTextarea.vue for why computing
  // this suffix reactively inside the computed broke Vuetify's form (un)registration.
  const idSuffix = Math.random().toString(36).slice(2, 7);

  const elementId = computed(() => {
    const _elementIdToken = attrs.id || attrs.label;

    return _elementIdToken ? `app-select-${_elementIdToken}-${idSuffix}` : undefined;
  });

  const label = computed(() => attrs.label as string | undefined);
  const mandatory = computed(() => attrs.mandatory as boolean);
</script>

<template>
  <div class="app-select flex-grow-1" :class="$attrs.class">
    <VLabel v-if="label" :for="elementId" class="mb-1 text-body-2 text-high-emphasis">
      {{ label }}
      <span v-if="mandatory" class="text-h6 text-error ms-1">*</span>
    </VLabel>
    <VSelect
      v-bind="{
        ...$attrs,
        class: null,
        label: undefined,
        variant: 'outlined',
        id: elementId,
        menuProps: {
          contentClass: [
            'app-inner-list',
            'app-select__content',
            'v-select__content',
            $attrs.multiple !== undefined ? 'v-list-select-multiple' : ''
          ]
        }
      }"
    >
      <template v-for="(_, name) in $slots" #[name]="slotProps">
        <slot :name="name" v-bind="slotProps || {}" />
      </template>
    </VSelect>
  </div>
</template>
